import { useEffect } from 'react';

import { trackingUtils } from '@debijenkorf/dbk-common';

import { type Navigation, type Product } from '@/types/api/product';
import { chunkArray } from '@/utilities/chunkArray';
import { PLP_TRACK_LOCATION } from '@/utilities/tracking/constants';
import { viewItemList } from '@/utilities/tracking/viewItemList';

type UseViewItemListTracking = {
  products: Navigation['products'];
};

export const useViewItemListTracking = ({ products }: UseViewItemListTracking) => {
  useEffect(() => {
    const productItems = Array.from(document.querySelectorAll('.js-hook-product-item'));
    const productGrid = document.querySelector('.js-hook-product-grid');
    const productGridColumns = productGrid
      ? Number(window.getComputedStyle(productGrid).getPropertyValue('--grid-columns'))
      : 4;

    let inViewProducts: (Product & { listIndex: number })[] = [];

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const listIndex = productItems.indexOf(entry.target);
            inViewProducts.push({ ...products[listIndex], listIndex });
            observer.unobserve(entry.target);
          }
        });

        const productChunks = chunkArray(inViewProducts, productGridColumns);

        productChunks?.forEach(products => {
          trackingUtils.pushToDataLayer(
            viewItemList({
              products,
              location: PLP_TRACK_LOCATION,
            }),
          );
        });

        inViewProducts = [];
      },
      { threshold: 0.75 },
    );

    productItems.forEach(item => observer.observe(item));
  }, [products]);
};
